module.exports = __webpack_public_path__ + "img/side-icon-11-off.bf88a109.svg";